/**
 * Justificativas de não possuir CPF — lista fechada do LEDI APS 8.4.2.
 *
 * PROCEDÊNCIA: transcrito de `lauduzone-backend/src/main/resources/esus/JUSTIFICATIVA-CPF-LEDI-8.4.2.md`
 * (layout LEDI APS **8.4.2**, seção `JustificativaNaoPossuiCpf`, consultado em 2026-09-05), que por
 * sua vez é a fonte do enum `JustificativaNaoPossuiCpfEsus` do backend. Códigos **2 a 13**: não
 * existe código 1 na fonte.
 *
 * ISTO É DUPLICAÇÃO DE **RÓTULO**, NUNCA DE REGRA. Quando a justificativa é exigida continua sendo
 * decidido por `GET /empresas/{id}/esus/cadastro-paciente` (fatia F3) — esta tabela só dá nome às
 * opções do combo. A duplicação existe porque **nenhum endpoint publica a lista** (conferido por
 * `grep` em `controllers/` e `models/dtos/` do backend: o enum só aparece em `DadosAdicionaisDto`,
 * na leitura, e o DTO de escrita recebe `Integer` cru).
 *
 * FOLLOW-UP DE BACKEND registrado na Dev Evidence da fatia F4: publicar as justificativas num
 * endpoint de catálogo (no molde de `GET /etnias` / `GET /paises`) e apagar este arquivo. Enquanto
 * ele existir, mudar de versão de LEDI obriga a atualizar os dois lados juntos.
 */

export type JustificativaNaoPossuiCpf = {
  codigo: number
  descricao: string
}

export const JUSTIFICATIVAS_NAO_POSSUI_CPF: JustificativaNaoPossuiCpf[] = [
  { codigo: 2, descricao: 'Paciente desacordado, sem documentos' },
  { codigo: 3, descricao: 'Recém-nascidos' },
  { codigo: 4, descricao: 'Indígenas sem CPF' },
  { codigo: 5, descricao: 'Pessoa em situação de rua sem documentos' },
  { codigo: 6, descricao: 'Recusa cultural ou religiosa' },
  { codigo: 7, descricao: 'Estrangeiro em trânsito (turista/visitante)' },
  { codigo: 8, descricao: 'Pessoa indocumentada' },
  { codigo: 9, descricao: 'Crianças sem documentação emitida' },
  { codigo: 10, descricao: 'Estrangeiro residente sem CPF' },
  { codigo: 11, descricao: 'Internação compulsória (saúde mental ou ordem judicial)' },
  {
    codigo: 12,
    descricao: 'População migrante/refugiada em processo de regularização',
  },
  { codigo: 13, descricao: 'Situações de calamidade ou desastre' },
]

/** Opções prontas para o combo, na ordem da fonte (que é a ordem crescente de código). */
export const OPCOES_JUSTIFICATIVA_NAO_POSSUI_CPF = JUSTIFICATIVAS_NAO_POSSUI_CPF.map(
  (justificativa) => ({
    label: justificativa.descricao,
    value: justificativa.codigo,
  })
)
